(function () {
    'use strict';

    function main() {

        var controller = {
            init: function() {
                var widget = wo$('[data-widget-type="mobile-phone-popular-suppliers"]');
                if (!widget.length) return;

                widget.find('#change-usage').off('click').on('click',
                    function() {
                        WhistleOut.trackEvent('MobilePhonePopularSuppliers', 'ChangeUsage');
                    });
                widget.find('#view-full-results').off('click').on('click',
                    function() {
                        WhistleOut.trackEvent('MobilePhonePopularSuppliers', 'ViewFullResults');
                    });
                widget.find('[data-goto-supplier]').off('click').each(function() {
                    var $this = wo$(this);
                    var supplier = $this.data('goto-supplier');
                    $this.on('click',
                        function() {
                            WhistleOut.trackEvent('MobilePhonePopularSuppliers', 'GoToSupplier', supplier);
                        });
                });
            }
        };

        WhistleOut.initWidget = controller.init;
        controller.init();
    };

    WhistleOut.initModule(import.meta.url, main);

}());